import { ReactNode } from 'react';

import { Label } from 'components/shared/Label';
import { EFlightStatus, ETripEvent } from 'detailsv2/structure';
import i18n from 'i18n';
import { isIDL } from 'utils/date';

import { IDayTripEvent } from '../types';
import s from './index.module.css';
import {
  AccommodationOption,
  ActivityOption,
  AreaOption,
  FlightOption,
  InformationOption,
  TransferOption,
} from './Options';
import { EventOptionConfig } from './types';

const baseConfig = {
  isDeletable: true,
  isDraggable: true,
  getLabel: () => null,
};

const getConfig = (customConfig: any) => {
  return {
    ...baseConfig,
    ...customConfig,
  };
};

export const EVENT_OPTION_CONFIG = {
  [ETripEvent.Flight]: getConfig({
    getContent: (data: IDayTripEvent<ETripEvent.Flight>, config: EventOptionConfig) => (
      <FlightOption {...data} {...config} />
    ),
    getLabel: (tripEvent: IDayTripEvent<ETripEvent.Flight>, config: EventOptionConfig) => {
      const labels: ReactNode[] = [];

      if (tripEvent.data.fromFsService) {
        const hideChanges = config?.readonly && !tripEvent.data.updateClientSide;

        if (tripEvent.data.flightStatus === EFlightStatus.Cancelled && !hideChanges) {
          labels.push(<Label color="#CE4622" text={i18n.t('proposal_content.event_details.flights.tags.cancelled')} />);
        } else if (tripEvent.data.flightStatus === EFlightStatus.Rescheduled && !hideChanges) {
          labels.push(<Label color="#1624C2" text={i18n.t('proposal_content.event_details.flights.tags.changed')} />);
        }
      }
      if (isIDL(tripEvent.daysRange.start, tripEvent.daysRange.end)) {
        labels.push(
          <Label
            color="#65ADFF"
            text={i18n.t('proposal_content.event_details.flights.tags.date_line')}
            tooltip={i18n.t('proposal_content.event_details.flights.tags.crosses_date_lines.details')}
            className={s.idl}
          />,
        );
      }
      return labels;
    },
  }),
  [ETripEvent.Transfer]: getConfig({
    getContent: (data: IDayTripEvent<ETripEvent.Transfer>, config: EventOptionConfig) => (
      <TransferOption {...data} {...config} />
    ),
  }),
  [ETripEvent.Area]: getConfig({
    getContent: (data: IDayTripEvent<ETripEvent.Area>) => <AreaOption {...data} />,
  }),
  [ETripEvent.Accommodation]: getConfig({
    getContent: (data: IDayTripEvent<ETripEvent.Accommodation>, config: EventOptionConfig) => (
      <AccommodationOption {...data} {...config} />
    ),
  }),
  [ETripEvent.Activity]: getConfig({
    getContent: (data: IDayTripEvent<ETripEvent.Activity>, config: EventOptionConfig) => (
      <ActivityOption {...data} {...config} />
    ),
  }),
  [ETripEvent.Information]: getConfig({
    getContent: (data: IDayTripEvent<ETripEvent.Information>) => <InformationOption {...data} />,
  }),
};
